'use client'
import { useScroll } from 'framer-motion'
import { SwiperSlide } from 'swiper/react'

import { FC, useRef } from 'react'

import { AnimationScrollTopComponent } from '@/app/shared/components/animation/scroll-top'
import { StepComponent } from '@/app/shared/components/start-study/elements/step'
import { generateStyle } from '@/app/shared/components/start-study/services'
import { IId } from '@/app/shared/interfaces/common.interface'
import { IContent, ITitleEditorList } from '@/app/shared/interfaces/content.interface'
import { clearData } from '@/app/shared/services/data-formatter'
import { ITypeSite } from '@/app/shared/store/layout.store'
import { ContainerComponent } from '@/app/shared/ui/container'
import { SliderComponent } from '@/app/shared/ui/slider'
import { TitleComponent } from '@/app/shared/ui/title'

// interface
interface IStartStudy extends IId {
  data: IStartStudyQuery
  typeSite: ITypeSite
}

export interface IStartStudyQuery {
  arrayTitleEditorImage: {
    title: string
    items: IContent[]
  }
}

// component
const StartStudyComponent: FC<Readonly<IStartStudy>> = ({ data, id, typeSite }) => {
  const arrTitlesEditor = clearData(data.arrayTitleEditorImage.items) as ITitleEditorList
  const containerEL = useRef<HTMLDivElement | null>(null)

  const { scrollYProgress } = useScroll({
    target: containerEL,
    offset: ['start end', 'center start'],
  })

  // return
  return (
    <ContainerComponent id={id}>
      <TitleComponent className={'mb-[50px] desktop:mb-[96px]'} animate>
        {data.arrayTitleEditorImage.title}
      </TitleComponent>
      <SliderComponent
        centeredSlides={true}
        slidesPerView={1.1}
        spaceBetween={20}
        arrow
        className={
          'order-1 !-ml-[30px] w-[calc(100%+60px)] laptop:!hidden [&>.swiper-wrapper]:items-stretch'
        }
      >
        {arrTitlesEditor.titleEditorImage.map((el, index) => (
          <SwiperSlide key={`${el.title}_${index}`} className={'!h-auto'}>
            <StepComponent
              data={el}
              count={`0${index + 1}`}
              className={'h-full items-start'}
              typeSite={typeSite}
            />
          </SwiperSlide>
        ))}
      </SliderComponent>
      <div
        className={'hidden grid-cols-2 items-start gap-x-[18px] gap-y-[128px] laptop:grid'}
        ref={containerEL}
      >
        {arrTitlesEditor.titleEditorImage.map((el, index) => (
          <AnimationScrollTopComponent
            start={generateStyle(index)}
            transform={scrollYProgress}
            key={index}
          >
            <StepComponent data={el} count={`0${index + 1}`} typeSite={typeSite} />
          </AnimationScrollTopComponent>
        ))}
      </div>
    </ContainerComponent>
  )
}

export default StartStudyComponent
